import axios from "../axiosApi";
import { FETCH_SCHOOL_AUTHS, RECEIVE_SCHOOL_AUTHS, SAVE_SCHOOL_AUTH, SAVE_SCHOOL_AUTH_SUCCESS, DELETE_SCHOOL_AUTH, DELETE_SCHOOL_AUTH_SUCCESS } from "../actionTypes";

export const getSchoolAuths = () => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_SCHOOL_AUTHS });
        try {
            const response = await axios.get('/SchoolAuthorizations');
            dispatch({ type: RECEIVE_SCHOOL_AUTHS, payload: response.data });
        } catch (e) {
            console.error("getSchoolAuths ERROR", e);
            dispatch({ type: RECEIVE_SCHOOL_AUTHS, payload: [] });
        }
    }
}

export const saveSchoolAuth = (data: any) => {
    return async (dispatch: any) => {
        dispatch({ type: SAVE_SCHOOL_AUTH });
        try {
            let response;
            if (data.id) {
                const id = data.id;
                delete data.id;
                response = await axios.put(`/SchoolAuthorizations/${id}`, data);
            } else {
                if (data.id === null) delete data.id;
                response = await axios.post('/SchoolAuthorizations', data);
            }
            dispatch({ type: SAVE_SCHOOL_AUTH_SUCCESS, payload: response.data });
            dispatch(getSchoolAuths());
        } catch (e) {
            console.error("saveSchoolAuth ERROR", e);
            dispatch({ type: SAVE_SCHOOL_AUTH_SUCCESS, payload: { error: true } });
        }
    }
}

export const deleteSchoolAuth = (id: number) => {
    return async (dispatch: any) => {
        dispatch({ type: DELETE_SCHOOL_AUTH });
        try {
            await axios.delete(`/SchoolAuthorizations/${id}`);
            dispatch({ type: DELETE_SCHOOL_AUTH_SUCCESS });
            dispatch(getSchoolAuths());
        } catch (e) {
            console.error("deleteSchoolAuth ERROR", e);
        }
    }
}
